module.exports = "/images/default-baby-or-adoption-background.png?38bc79ca7fa1835a01440748a63f113a";